import React from 'react';
import { Chip, Typography } from '@mui/material';
import { ICourseData } from '../../types/course-data';
import ProgressBar from './progress-bar';
import { adaptCourseTypeText } from 'src/shared/utils/adapt-course-type-text';
import { MarkdownRenderer } from 'src/shared/components/markdown-renderer';

interface ModalDescriptionProps {
  description: string;
  tagColor: { text: string; bg: string };
  tagText: string;
  lessons: ICourseData['lessons'];
}
export const ModalDescription: React.FC<ModalDescriptionProps> = ({
  description,
  lessons,
  tagColor,
  tagText,
}) => {
  return (
    <div className="flex flex-col gap-6 w-full">
      <div className="gap-y-2">
        <Chip
          label={<Typography variant="button-s">{adaptCourseTypeText(tagText)}</Typography>}
          size="medium"
          sx={{ color: tagColor.text, backgroundColor: tagColor.bg }}
          variant="filled"
          className="self-start"
        />
        <div className="mt-2 text-base font-medium leading-6 text-text-secondary">
          <MarkdownRenderer markdown={description} />
        </div>
      </div>

      <div className="flex justify-between gap-4">
        <ProgressBar lessons={lessons} />
      </div>
    </div>
  );
};
